import { Link, useLocation } from 'react-router-dom'

import logo from '../assets/logo.png'
import { cn } from '../libs/tailwindMerge'
import { HeaderActions } from './HeaderActions'

export function Header() {
  const { pathname } = useLocation()
  return (
    <div className={cn(
      'flex flex-col mx-auto max-w-screen-lg',
      pathname === '/terms' && 'hidden',
    )}
    >
      <header className="flex w-full justify-between items-center py-4 px-4 xl:px-0">
        <Link
          to={pathname.includes('/temporary')
            ? '#'
            : '/dashboard'}
          onClick={(e) => pathname.includes('/temporary') && e.preventDefault()}
          className="flex flex-col justify-center"
        >
          <img
            src={logo}
            alt="NJF Alimentos"
            className="w-20"
          />
          <span className="text-center text-xs font-bold hidden sm:inline">Relatórios de Trade Marketing</span>
        </Link>
        {!pathname.includes('/temporary') && (
          <HeaderActions />
        )}
      </header>
    </div>
  )
}
